import React, { } from 'react';
import {TablePagination} from '@material-ui/core';

const Paginate = (props) => {
    const { rowsPerPageOptions, count, rowsPerPage, page, onChangePage, onChangeRowsPerPage, style } = props;

    return (
        <TablePagination
            style={{... style}}
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{ 'aria-label': 'página anterior',}}
            nextIconButtonProps={{ 'aria-label': 'próxima página', }}
       
            onChangePage={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            labelRowsPerPage="Selecione"
        />
    );
}

export default Paginate;